import { render, staticRenderFns } from "./PageDesignerDetail.vue?vue&type=template&id=5f5c2064&scoped=true&"
import script from "./PageDesignerDetail.vue?vue&type=script&lang=js&"
export * from "./PageDesignerDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageDesignerDetail.vue?vue&type=style&index=0&id=5f5c2064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c2064",
  null
  
)

export default component.exports